import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite'
import Team from './Team'
import clubStore from '../../../storage/ClubStore'

const NewTeam = () => {
  useEffect(() => {
    clubStore.resetTeam()
  }, []);
  return (
    <Team/>
  );
};

export default observer(NewTeam);